export enum ComplianceFlowType {

    StandardDepositAfterKyc = 1,
    AuthorizationSettlement = 2,
    StandardDepositBeforeKyc = 3,
    CNMVOnBoarding = 4,
}
